import { createTheme } from '@mui/material';
import { components } from './components';
import { baseTheme } from './baseTheme';

const theme = createTheme({ ...baseTheme, components });

export default theme;
